import { render, staticRenderFns } from "./RefiningItem.vue?vue&type=template&id=5ac477ec&scoped=true"
import script from "./RefiningItem.vue?vue&type=script&lang=js"
export * from "./RefiningItem.vue?vue&type=script&lang=js"
import style0 from "./RefiningItem.vue?vue&type=style&index=0&id=5ac477ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac477ec",
  null
  
)

export default component.exports